import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { isSuperAdmin } from '../../utils/functions';

const RequireSuperAdmin: React.FC = () => {
  if (!isSuperAdmin()) {
    return <Navigate to="/acesso-negado" replace />;
  }
  return <Outlet />;
};

export default RequireSuperAdmin;
